// Copyright (c) 2016 Deere & Company

import {
    addFile,
    deleteFile
} from './file-attachment';
import {
    addLabor,
    changeLaborLocation,
    changeLaborProperty,
    changeLaborType,
    deleteLabor
} from './labor';
import {
    addPart,
    changePartProperty,
    changePartsUnit,
    deletePart
} from './parts';
import {
    changeAmount,
    changeComments,
    changeDescription,
    changeDistance,
    createOtherCredit,
    deleteOtherCredit
} from './other-credits';
import {
    onCreateClaim,
    updateClaimModalMode,
    updateCreateClaimModalVisibility
} from './create-claim-modal-visibility';
import {
    resetBatteryClaim,
    resetBatteryPinDetails,
    resetBatteryProductDetails,
    updateBatteryClaimApplication,
    updateBatteryClaimFailureDate,
    updateBatteryClaimFailurePart,
    updateBatteryClaimInputOnBlur,
    updateBatteryClaimPin,
    updateBatteryClaimProperty,
    updateBatteryClaimRepairDate,
    updateBatteryClaimRepairNumber,
    updateBatteryClaimUnitDropDown,
    updateBatteryClaimUseAmount,
    updateBatteryClaimWorkOrderOne,
    updateBatteryClaimWorkOrderTwo,
    updateInstalledByDropDown,
    updateOwnershipStatusDropDown,
    updateResponsibleAccountsDropDown,
    updateStickyHeaderVisibility
} from './claim-details';
import {
    resetConfirmationModal,
    setConfirmationModal
} from './confirmation-modal';
import {
    updateBatteryClaimBasisForSettlement,
    updateBatteryClaimComplaintCause,
    updateBatteryClaimComplaintCorrection,
    updateBatteryClaimDtacCase,
    updateBatteryClaimDtacSolution,
    updateBatteryClaimFailedModeComments,
    updateBatteryClaimOperatorComments,
    updateBatteryClaimOperatorsComplaint,
    updateBatteryClaimPartSerialNumber,
    updateFailedModeDropDown
} from './failure-panel';
import {additionalRepair} from './additional-repair';
import {copyAttachments} from '../../shared/action-creators/copy-attachment';
import {copyClaim} from './copy-claim';
import {createBatteryClaim} from './validate-claim';
import {onEditClaim} from '../../shared/action-creators/edit-claim';
import {readApplication} from './get-application';
import {readBatteryClaim} from './get-battery-claim';
import {readClaimProduct} from './get-product-details';
import {readClaimTypes} from './get-claim-types';
import {readFailureModes} from './failure-modes';
import {readGoodsInstallationVatOptions} from '../../shared/action-creators/get-goods-installation-vat-options';
import {readInstalledBy} from './get-installed-by';
import {readLaborLocations} from '../../shared/action-creators/labor-locations';
import {readLaborTypes} from '../../shared/action-creators/labor-types';
import {readOtherCreditDescriptions} from '../../shared/action-creators/other-credit-descriptions';
import {readOwnershipStatuses} from '../../shared/action-creators/ownership-status';
import {readPartDetails} from './get-part-details';
import {resetCkcCustomerFailure} from '../../../shared/action-creators/customer-failed';
import {resetCustomerDetails} from './reset-customer-details';
import {resetLatestPerUnitMeasurements} from '../../../shared/action-creators/latest-per-unit-measurements';
import {toggleWarrentyStatusModal} from '../../shared/action-creators/warranty-status-modal';
import {updateGoodsInstallationVat} from './update-goods-installation-vat';
import {updateIsEditable} from './is-editable';
import {updateSelectedAction} from './update-selected-action';
import {updateTemporaryObjectKey} from './update-temporary-object-key';
import {updateWarranties} from '../../../product/details/action-creators/warranties';

export default {
    addFile,
    addLabor,
    addPart,
    additionalRepair,
    changeAmount,
    changeComments,
    changeDescription,
    changeDistance,
    changeLaborLocation,
    changeLaborProperty,
    changeLaborType,
    changePartProperty,
    changePartsUnit,
    copyAttachments,
    copyClaim,
    createBatteryClaim,
    createOtherCredit,
    deleteFile,
    deleteLabor,
    deleteOtherCredit,
    deletePart,
    onCreateClaim,
    onEditClaim,
    readApplication,
    readBatteryClaim,
    readClaimProduct,
    readClaimTypes,
    readFailureModes,
    readGoodsInstallationVatOptions,
    readInstalledBy,
    readLaborLocations,
    readLaborTypes,
    readOtherCreditDescriptions,
    readOwnershipStatuses,
    readPartDetails,
    resetBatteryClaim,
    resetBatteryPinDetails,
    resetBatteryProductDetails,
    resetCkcCustomerFailure,
    resetConfirmationModal,
    resetCustomerDetails,
    resetLatestPerUnitMeasurements,
    setConfirmationModal,
    toggleWarrentyStatusModal,
    updateBatteryClaimApplication,
    updateBatteryClaimBasisForSettlement,
    updateBatteryClaimComplaintCause,
    updateBatteryClaimComplaintCorrection,
    updateBatteryClaimDtacCase,
    updateBatteryClaimDtacSolution,
    updateBatteryClaimFailedModeComments,
    updateBatteryClaimFailureDate,
    updateBatteryClaimFailurePart,
    updateBatteryClaimInputOnBlur,
    updateBatteryClaimOperatorComments,
    updateBatteryClaimOperatorsComplaint,
    updateBatteryClaimPartSerialNumber,
    updateBatteryClaimPin,
    updateBatteryClaimProperty,
    updateBatteryClaimRepairDate,
    updateBatteryClaimRepairNumber,
    updateBatteryClaimUnitDropDown,
    updateBatteryClaimUseAmount,
    updateBatteryClaimWorkOrderOne,
    updateBatteryClaimWorkOrderTwo,
    updateClaimModalMode,
    updateCreateClaimModalVisibility,
    updateFailedModeDropDown,
    updateGoodsInstallationVat,
    updateInstalledByDropDown,
    updateIsEditable,
    updateOwnershipStatusDropDown,
    updateResponsibleAccountsDropDown,
    updateSelectedAction,
    updateStickyHeaderVisibility,
    updateTemporaryObjectKey,
    updateWarranties
};



// WEBPACK FOOTER //
// ./src/claim/battery/action-creators/index.js